import Category from '../views/categories/Index.vue';
import { checkauth } from '../Helper';

// inserimento e modifica sono pagine: tornando indietro la lista riparte dal suo URL
const CategoryCreate = () => import('../views/categories/Create.vue');
const CategoryEdit = () => import('../views/categories/Edit.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	{
		path: '/categories',
		name: 'category',
		component: Category,
		beforeEnter: auth,
	},
	// prima di /categories/:id, altrimenti "new" verrebbe letto come un id
	{
		path: '/categories/new',
		name: 'category-new',
		component: CategoryCreate,
		beforeEnter: auth,
	},
	// :id e' l'id numerico della categoria (colonna "Id" della lista)
	{
		path: '/categories/:id(\\d+)',
		name: 'category-edit',
		component: CategoryEdit,
		beforeEnter: auth,
	},
];
